/**
 * Verbal+Visual
 * ---------------------------------------------------------------------------
 */

function waitForElement(querySelector, timeout) {
  return new Promise((resolve, reject) => {
    var timer = false;
    if (document.querySelectorAll(querySelector).length) return resolve();
    const observer = new MutationObserver(() => {
      if (document.querySelectorAll(querySelector).length) {
        observer.disconnect();
        if (timer !== false) clearTimeout(timer);
        return resolve();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    if (timeout)
      timer = setTimeout(() => {
        observer.disconnect();
        reject();
      }, timeout);
  });
}

document.addEventListener("DOMContentLoaded", function (event) {
  // Homescreen Youtube Video
  if (document.querySelector(".full-screen-video")) {
    setYoutubeVideo();
  }

  // Shopify Pay Accessiblity
  if (document.getElementById("shopify-section-cart-template")) {
    setPayButtonAccesibility();
  }

  // Review Accessiblity
  if (document.querySelector(".product-grid-item .review")) {
    setAccessibleReviews();
  }

  // International Modal
  initInternationalModal();

  // Mobile Menu Accessibility
  initMobileMenuAriaState();

  // Search Status Message Accessibility
  if (document.querySelector(".template-search")) {
    history.scrollRestoration = "manual";
    // document.getElementById('h1').focus();
    // window.location.hash = 'h1';
  }

  // Util Header Scroll Trigger
  scrollTriggerHeaderUtil();

  //Yotpo Scroll Hack
  scrollHack();

  // Rewards Page Hack
  rewardsPageHack();

  // Yotpo Ratings Hack
  yotpoRatingsHack();
});

const internationalModalStorageKey = "international_modal";
const internationalModalCookieDays = 30;
const northAmericaCountries = ["US", "CA", "MX"];

function initMobileMenuAriaState() {
  const panel = document.getElementById("menu");
  if (!panel) {
    return;
  }

  const syncPanelState = () => {
    const isOpen =
      document.documentElement.classList.contains("panel-open") ||
      document.body.classList.contains("panel-open");

    panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
  };

  syncPanelState();

  const observer = new MutationObserver(syncPanelState);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["class"],
  });
}

function initInternationalModal() {
  const modal = document.getElementById("international-popup-modal");
  if (!modal || hasInternationalModalPreference()) {
    return;
  }

  const defaultCountry = normalizeCountryCode(
    modal.getAttribute("data-current-site")
  );
  const userCountry = getInternationalUserCountry(modal);

  if (!defaultCountry || !userCountry) {
    persistInternationalModalPreference();
    return;
  }

  if (shouldShowInternationalModal(userCountry, defaultCountry)) {
    setInternationalModal();
  } else {
    persistInternationalModalPreference();
  }
}

function getInternationalUserCountry(modal) {
  const shopifyCountryCookie = normalizeCountryCode(getCookie("_shopify_country"));
  if (shopifyCountryCookie) {
    return shopifyCountryCookie;
  }

  return normalizeCountryCode(modal.getAttribute("data-shopify-country"));
}

function shouldShowInternationalModal(userCountry, defaultCountry) {
  const userInNorthAmerica = northAmericaCountries.includes(userCountry);
  const defaultSiteInNorthAmerica = northAmericaCountries.includes(defaultCountry);

  return userInNorthAmerica !== defaultSiteInNorthAmerica;
}

function hasInternationalModalPreference() {
  return (
    getStorageItem(localStorage, internationalModalStorageKey) === "true" ||
    getStorageItem(sessionStorage, internationalModalStorageKey) === "true" ||
    getCookie(internationalModalStorageKey) === "true"
  );
}

function persistInternationalModalPreference() {
  setStorageItem(localStorage, internationalModalStorageKey, "true");
  setStorageItem(sessionStorage, internationalModalStorageKey, "true");
  setCookie(
    internationalModalStorageKey,
    "true",
    internationalModalCookieDays
  );
}

function getStorageItem(storage, key) {
  try {
    return storage.getItem(key);
  } catch (error) {
    return null;
  }
}

function setStorageItem(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch (error) {}
}

function getCookie(name) {
  const cookieName = `${name}=`;
  const matchingCookie = document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(cookieName));

  if (!matchingCookie) {
    return null;
  }

  return decodeURIComponent(matchingCookie.substring(cookieName.length));
}

function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
}

function normalizeCountryCode(value) {
  if (!value) {
    return "";
  }

  return String(value).trim().toUpperCase();
}

function setInternationalModal() {
  document.getElementById("international-popup-modal").style.display = "block";
  document.body.classList.add("dialog-open");
  setListeners();
}

function setListeners() {
  document.getElementById('international-popup-modal').addEventListener("click", function (e) {
    if (e.target !== this) {
      return;
    }
    closeInternationalModal();
  });

  document.getElementById('forward_to_site').addEventListener("click", function () {
    closeInternationalModal();
  });

  document.getElementById('return_to_site').addEventListener("click", function () {
    closeInternationalModal();
  });


  document.getElementById("close_popup").addEventListener("click", function () {
    closeInternationalModal();
  });
}

function closeInternationalModal() {
  document.getElementById("international-popup-modal").style.display = "none";
  persistInternationalModalPreference();
  document.body.classList.remove("dialog-open");
}

function setYoutubeVideo() {
  var tag = document.createElement("script");
  tag.id = "iframe-demo";
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  var player;
  window.onYouTubeIframeAPIReady = function () {
    player = new YT.Player("full-screen-video-player", {
      playerVars: { autoplay: 1, controls: 0, mute: 1 },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
        onError: onPlayerError,
      },
    });
  };

  function onPlayerError(error) {}

  function onPlayerReady(event) {
    setMuteButtonListener();
  }

  function onPlayerStateChange(event) {}

  function setMuteButtonListener() {
    document.getElementById("video_cta").addEventListener("click", function () {
      if (player.isMuted()) {
        player.unMute();
        player.setVolume(100);
        this.setAttribute("aria-pressed", "true");
      } else {
        player.mute();
        this.setAttribute("aria-pressed", "false");
      }
    });
  }
}

function setPayButtonAccesibility() {
  var interval = setInterval(addClickListener, 3000);
  function addClickListener() {
    document
      .querySelectorAll(".additional-checkout-buttons div[role=button]")
      .forEach((button) => {
        clearInterval(interval);
        button.addEventListener("keyup", function (e) {
          if (e.code === "Enter") {
            button.click();
          }
        });
      });
  }
}

function setAccessibleReviews() {
  var interval = setInterval(setReview, 3000);
  function setReview() {
    if (document.querySelector(".spr-starrating.spr-badge-starrating")) {
      const ratingContainer = document.querySelectorAll(
        ".spr-starrating.spr-badge-starrating"
      );
      ratingContainer.forEach((el) => {
        const parentEl = el.parentElement;
        const rating = Number(parentEl.dataset.rating);
        if (rating) {
          const hiddenStarCount = document.createElement("span");
          hiddenStarCount.classList = "visually-hidden";
          hiddenStarCount.innerText = `${rating.toFixed(1)} stars`;
          el.insertAdjacentElement("beforebegin", hiddenStarCount);
        }
      });
      clearInterval(interval);
      $(".spr-starrating.spr-badge-starrating").attr("aria-hidden", "true");
    }
  }
}

function scrollTriggerHeaderUtil() {
  /*
  const globalHeader = document.querySelector('.global-header');
  const utilHeader = document.querySelector('.util.header-util');

  let globalHeaderHeight = globalHeader.getClientRects()[0].height;
  let utilHeaderHeight = utilHeader.getClientRects()[0].height;
  const scrollTriggerPoint = globalHeaderHeight - utilHeaderHeight;

  let isTriggered = false;

  if (window.scrollY > scrollTriggerPoint && !isTriggered) {
    utilHeader.classList.add("scroll-triggered");
  }

  window.addEventListener("scroll", () => {
    if (window.scrollY > scrollTriggerPoint && !isTriggered) {
      utilHeader.classList.add("scroll-triggered");
      globalHeader.style.height = `${globalHeaderHeight}px`;
      isTriggered = true;
    } else if (window.scrollY <= scrollTriggerPoint && isTriggered) {
      utilHeader.classList.remove("scroll-triggered");
      globalHeader.removeAttribute("style");
      isTriggered = false;
    }
  });
  */

  function reCalcHeight() {
    const globalHeader = document.querySelector('.global-header');
    let globalHeaderHeight = globalHeader.getClientRects()[0].height;
    document.getElementById('page').style.paddingTop = `${globalHeaderHeight}px`;
  }

  setTimeout(reCalcHeight, 300);

  window.addEventListener('resize', reCalcHeight);
}

// this is used on PDP where Yotpo tries to jump to full review widget - we have to adjust the scroll by few pixels but cannot modify the yotpo widget JS
function scrollHack() {
  $(".scroll-hack").click(() => {
    const listener = (e) => {
      window.removeEventListener("scroll", listener);
      window.scrollBy({ behavior: "instant", top: -150 });
    };
    window.addEventListener("scroll", listener);
  });
}

// Rewards Page Hack
function rewardsPageHack() {
  let targetNode = document.querySelector('.yotpo-widget-instance');
  if (window.location.pathname != '/pages/rewards' || !targetNode ) {
    return false;
  }
  targetNode = targetNode.closest('.shopify-section');
  // Options for the observer (which mutations to observe)
  const config = { subtree: true, childList: true };
  // Callback function to execute when mutations are observed
  const callback = () => {
    let titleEl = targetNode.querySelector('.yotpo-title');
    if (titleEl) {
      let title_h1 = document.createElement('h1');
      title_h1.classList.add(titleEl.classList);
      title_h1.style = titleEl.style;
      title_h1.textContent = titleEl.textContent;
      titleEl.replaceWith(title_h1);
      observer.disconnect();
    }
  };
        
  // Create an observer instance linked to the callback function
  let observer = new MutationObserver(callback);
  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
}

// Yotpo Ratings Hack
function yotpoRatingsHack() {
  waitForElement('.yotpo-reviews-star-ratings-widget [role=img]', 10000).then(() => {
    setTimeout(function() {
      const starWidgets = document.querySelectorAll('.yotpo-reviews-star-ratings-widget');
      for (var i in starWidgets) {
        const img = starWidgets[i].querySelector('[role=img]');
        if (!img) {
          continue;
        }        
        const ratingLabel = img.attributes['aria-label'].value;
        starWidgets[i].parentElement.nextElementSibling.insertAdjacentHTML('beforeend', '<span class="rating"> <span class="sr-only">' + ratingLabel + '</span></span>');
      }
    }, 2000);
  });
}

// Add event listener for keydown event
document.addEventListener("keydown", function (event) {
  // Select all elements with the class ".ls-carousel-photo"
  const carouselItems = document.querySelectorAll(".ls-carousel-photo");

  // Iterate over each element
  carouselItems.forEach((item) => {
    // Check if the currently focused element matches the current carousel item
    if (
      document.activeElement === item &&
      (event.key === " " || event.key === "Enter")
    ) {
      event.preventDefault(); // Prevent the default behavior of the spacebar key
      item.click(); // Trigger a click event if the focused element matches a carousel item and spacebar or enter key is pressed
    }
  });
});
/*js --------------------jorge perez-------------------------------- */
window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {

    /* slider pdp -*/
      let sliderElements = document.querySelectorAll('.product-thumb--slider.flickity-enabled');
      sliderElements.forEach(function(element) {
      element.setAttribute('role', 'region');
      element.setAttribute('aria-roledescription', 'carousel');
      });
    /* end slide pdp */   
    /* pdp dots */
    const dots = document.querySelectorAll('.flickity-page-dots .dot');
    const dotsButtons = document.querySelectorAll('.flickity-page-dots button');
    const divs = document.querySelectorAll('.product-thumb--cell');
    
    if (dotsButtons.length > 0) {
        dotsButtons[0].setAttribute('aria-current', 'true');
        dotsButtons[0].setAttribute('aria-selected', 'true');
    }
    
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            dotsButtons.forEach((d) => {
                d.classList.remove('is-selected');
                d.setAttribute('aria-selected', 'false');
                d.setAttribute('aria-current', 'false');
            });
            dot.classList.add('is-selected');
            dot.setAttribute('aria-selected', 'true');
            dot.setAttribute('aria-current', 'true');
        });
    });
    
    divs.forEach((div, index) => {
        div.addEventListener('click', () => {
            dotsButtons.forEach((d) => {
                d.classList.remove('is-selected');
                d.setAttribute('aria-selected', 'false');
                d.setAttribute('aria-current', 'false');
            });
    
            dots[index].classList.add('is-selected');
            dots[index].setAttribute('aria-selected', 'true');
            dots[index].setAttribute('aria-current', 'true');
    
        });
    });

    // end pagination pdp carousel
    
    //slider dot
    const list = document.querySelector('.custom.desktop');
    if(list) {
    const buttons = list.querySelectorAll('button');
    
    buttons.forEach(button => {
      const li = button.querySelector('li');
      if (li.classList.contains('is-selected')) {
        button.setAttribute('aria-selected', 'true');
        button.setAttribute('aria-current', 'true');
      } else {
        button.setAttribute('aria-selected', 'false');
        button.setAttribute('aria-current', 'false');
      }
    });
    }

    //slider aria label end
    /* add focus to element that open navigation on mobile */
    let closeMdal = document.querySelector(".mobile-menu-overlay .menu-close");
    if (closeMdal) {
      let atrr = document.createAttribute('aria-label');
      atrr.value="close menu"
      closeMdal.setAttributeNode(atrr)
      //validate variable//
      closeMdal.addEventListener("click", function (e) {
        //add listener to add focus when clicked on X
        let menuOpen = document
          .querySelector(".header-util li.mobile-menu button.toggle-menu")
          .focus(); //return focus to element tha open the modal
      });
    }
    /* end  add focus to element that open navigation on mobile */

    /* add attribute to container slider */
    let sliderHudson = document.querySelector(
      ".dh-widget-container .ls-slider-container"
    );

    if (sliderHudson) {
      //validate variable
      //add atrr role
      let atrributeRole = document.createAttribute("role");
      atrributeRole.value = "region";
      sliderHudson.setAttributeNode(atrributeRole);

      //add atrr aria-roledescription
      let atrributeDesc = document.createAttribute("aria-roledescription");
      atrributeDesc.value = "carousel";
      sliderHudson.setAttributeNode(atrributeDesc);

      //add atrr aria labelledby
      let atrributeAria = document.createAttribute("aria-label");
      atrributeAria.value = "Discover our products through rotating images";
      sliderHudson.setAttributeNode(atrributeAria);

      /* add atrribute to container slide */
      let slides = document.querySelectorAll(
        ".dh-widget-container .slick-slide"
      );
      let slideImgs = document.querySelectorAll(
        ".dh-widget-container .slick-slide img"
      );

      slides.forEach(function (slide, index) {
        //iterate each element and add attr
        let atrributeSlide = document.createAttribute("role");
        atrributeSlide.value = "group";
        slide.setAttributeNode(atrributeSlide);

        let atrributeDescSlide = document.createAttribute(
          "aria-roledescription"
        );
        atrributeDescSlide.value = "carousel";
        slide.setAttributeNode(atrributeDescSlide);

        let attributeAriaAtomic = document.createAttribute("aria-atomic");
        attributeAriaAtomic.value = "false";
        slide.setAttributeNode(attributeAriaAtomic);

        let attributeAriaLive = document.createAttribute("aria-live");
        attributeAriaLive.value = "off";
        slide.setAttributeNode(attributeAriaLive);

        let atrrImg = slideImgs[index].getAttribute("alt");
        let atrributeAriaSlide = document.createAttribute("aria-label");
        atrributeAriaSlide.value = `${atrrImg}`;
        slide.setAttributeNode(atrributeAriaSlide);
      });
      /* end add atrribute to container slide */
    }

    /* end add attribute to container slider */
  }, 1000);

  /* sub menu plain text */
  let container = document.querySelectorAll(".has-sub-dropdown");

  if (container) {
    // validate variable
    let subDropDown = document.querySelectorAll(".has-sub-dropdown > a");
    subDropDown.forEach(function (e, i) {
      //iterar each element to change tag to span
      let content = e.textContent;
      let span = document.createElement("span");
      span.innerHTML = `${content}`;
      container[i].replaceChild(span, e);
    });
    /* end sub menu plain text */
  }

  /* incorrect focus order move cookie to button of body */
  let interval = setInterval(myCallback, 1000); //add interval to waiting for the cookie div load

  function myCallback() {
    let cookie = document.querySelector("#cookie-consent-dialogBox");
    if (cookie) {
      //validate varible
      let footer = document.querySelector(".new-footer");
      var parentDiv = footer.parentNode;
      parentDiv.insertBefore(cookie, footer.nextSibling);
      let cookieBtn = document.querySelector('#cookie-consent-dialogBox .cc-dismiss');
      cookieBtn.setAttribute('aria-label','agree cookie message');
      clearInterval(interval);
    }
  }
  /* end incorrect focus order move cookie to button of body */

  /* order focus search tab */
  let search = document.querySelector(
    ".header-util form.search-bar .icon-close"
  );
  if (search) {
    //validate variable
    let iconSearch = document.querySelector(".header-util .search");
    let links = document.querySelectorAll("ul.text-links.text-login a");
    search.addEventListener("click", function (e) {
      //listener to add atrr
      iconSearch.focus();
      links.forEach(function (l) {
        //iterate each element to add focus
        l.removeAttribute("tabindex");
      });
    });

    iconSearch.addEventListener("click", function (e) {
      //listener to remove change value atrr
      links.forEach(function (l) {
        let atr = document.createAttribute("tabindex");
        atr.value = "-1";
        l.setAttributeNode(atr);
      });
    });
  }

  /* end order focus search tab */

  /*  expanded menu items when press arrow down and navigate within menu items with arrows */

  const menu = document.querySelector(".nav-bar");
  const menuItems = menu.querySelectorAll(".has-dropdown button");
  let SubMenu = document.querySelectorAll(".nav-bar .dropdown");
  let subMenuItems = document.querySelectorAll(
    ".site-header .has-dropdown ul li a"
  );
  let currentItem = 0;
  let currentItemSubMenu = -1;

  menu.addEventListener("keydown", (event) => {
    //listener when a key is pressed in the menu
    const focusedElement = document.activeElement;
    let flag = false;
    
    if (event.key === "Tab" || event.key === "9") {
      currentItemSubMenu++; //increase counter when press key tab
      //let activeSubItem = menu.querySelector('.dropdown-hover');
      //currentItem = Array.from(activeSubItem.parentElement.children).indexOf(activeSubItem);
    }

    if (event.key === "ArrowLeft" || event.key === "37") {
      let button = focusedElement.parentElement; //detecting element whith focus
      let child = button.previousElementSibling; //detect if have a previos siblings

      if (
        focusedElement.classList.contains("custom-class-link") ||
        focusedElement.classList.contains("sub-custom-class-link")
      ) {
        //valida the focus
        let parent = focusedElement.parentElement.parentElement.parentElement; //found element with focus into the nav
        if (parent.previousElementSibling) {
          //validate if have a previous siblings
          let prevBtn = parent.previousElementSibling; //save in a variable
          prevBtn.querySelector(".custom-class").focus(); //found and give focus to previos element in tha nav
        } else {
          menuItems[menuItems.length - 1].focus(); //give focus to the last element into the nav **
        }
        if (parent.classList.contains("has-sub-dropdown")) {
          // validate if the focus has it this item with this class
          let subMenuLink =
            parent.parentElement.parentElement.previousElementSibling; //found element with focus into the nav
          if (subMenuLink === null) {
            // validate if is null
            menuItems[menuItems.length - 1].focus(); // give focus last element into the nav
          }
          parent = parent.parentElement.parentElement; //found element whith focus
          if (parent.previousElementSibling) {
            //vslidate element if have a siblings
            menuItems[menuItems.length - 1].blur(); // remove focus to the last item into the nav (line with **
            menuItems[menuItems.length - 2].focus(); // give focus to the previous siblings
          }
        }
      } else if (button.previousElementSibling) {
        child.querySelector(".custom-class").focus();
        currentItem--;
      } else {
        menuItems[menuItems.length - 1].focus();
      }

      menuItems.forEach(function (e) {
        //remove class active all items into nav
        e.parentNode.classList.remove("active");
      });

      flag = true;
      
    } else if (event.key === "ArrowRight" || event.key === "39") {
      let button = focusedElement.parentElement; //detecting element whith focus
      let child = button.nextElementSibling; //detect if have a previous siblings

      if (
        focusedElement.classList.contains("custom-class-link") ||
        focusedElement.classList.contains("sub-custom-class-link")
      ) {
        //valida the focus
        let parent =
          focusedElement.parentElement.parentElement.parentElement
            .nextElementSibling; //found element with focus into the nav
        if (parent === null) {
          // validate if is null
          menuItems[0].focus(); // give focus first element into the nav
        } else if (parent.classList.contains("has-sub-dropdown")) {
          // validate if the focus has it this item with this class
          let subMenuLink =
            parent.parentElement.parentElement.nextElementSibling; //found element with focus into the nav
          if (subMenuLink === null) {
            // validate if is null
            parent = parent.parentElement.parentElement.parentElement; // found element with focus
            menuItems[0].focus(); // give focus first element into the nav
          } else {
            return;
          }
        }

        parent.querySelector(".custom-class").focus();
      } else if (button.nextElementSibling) {
        let btn = button.nextElementSibling.querySelector(".custom-class");
        btn && btn.focus();
      } else {
        menuItems[0].focus();
      }

      menuItems.forEach(function (e) {
        //remove class active all items into nav
        e.parentNode.classList.remove("active");
      });

      flag = true;
      
    } else if (event.key === "ArrowDown" || event.key === "40") {
      // validate when pressed key arrow-down
      focusedElement.parentNode.classList.add("active");
      let subMenuItems = document.querySelectorAll(
        ".site-header .has-dropdown.dropdown-hover ul li a"
      );

      currentItemSubMenu++; // increase counter with each press key

      if (currentItemSubMenu > subMenuItems.length - 1) {
        currentItemSubMenu = 0;
      } else if (focusedElement.classList.contains("custom-class")) {
        currentItemSubMenu = 0;
        focusedElement.parentNode.classList.add("active");
      }

      subMenuItems[currentItemSubMenu].focus();
      flag = true;
      
    } else if (event.key === "ArrowUp" || event.key === "38") {
      //validate when pressed key aroow-up
      let subMenuItems = document.querySelectorAll(
        ".site-header .has-dropdown.dropdown-hover ul li a"
      );
      currentItemSubMenu--; // increase counter with each press key get items sub-menu to current item
      if (currentItemSubMenu < 0) {
        currentItemSubMenu = subMenuItems.length - 1;
      }
      subMenuItems[currentItemSubMenu].focus();

      flag = true;
      
    } else if (event.key === "Escape" || event.key === "27") {
      // validate when pressed key escape
      //menuItems[currentItem].parentNode.classList.remove("active"); //remove class active to each item menu
      //menuItems[currentItem].focus(); //return focus to current item menu
      let activeSubmenu = menu.querySelector('.dropdown-hover');
      if (activeSubmenu) {
        activeSubmenu.classList.remove('active');
        activeSubmenu.children[0] && activeSubmenu.children[0].focus();
      }

      flag = true;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  });
  /* end  expanded menu items when press arrow down and navigate within menu items with arrows */
  
  setTimeout(() => {
    let ariaSelected = document.querySelectorAll(".flickity-slider div");
    ariaSelected.forEach(function (e) {
      e.removeAttribute("aria-selected");
    });

    let sliderSlide = document.querySelectorAll(
      ".ls-slider-widget-container .ls-carousel-photo"
    );
    if (sliderSlide) {
      let atrrSLide = document.querySelectorAll(
        ".dh-widget-container .slick-initialized .slick-slide"
      );
      sliderSlide.forEach(function (slide, i) {
        let atrrSlideDesc = document.createAttribute("aria-describedby");
        atrrSlideDesc.value = atrrSLide[i].getAttribute("aria-label");
        slide.setAttributeNode(atrrSlideDesc);

        let atrrSlideLblldy = document.createAttribute("aria-labelledby");
        atrrSlideLblldy.value = "open dialog";
        slide.setAttributeNode(atrrSlideLblldy);
      });
    }
  }, 3000);

  
  setTimeout(() => {
    

    let inputsSubscribe = document.querySelectorAll('.rc-template__legacy-radio .rc-radio__label');
      if(inputsSubscribe) {
      inputsSubscribe.forEach(function(input) {
      let atrrLabel = document.createAttribute("tabindex");
        atrrLabel.value = "0";
        input.setAttributeNode(atrrLabel);

      input.addEventListener('keydown', function(event){
        if(event.key === "Enter") {
          event.target.click()
        }
      })
      
    })
  }
}, 20000);

 

  setTimeout(() => {
    
  
    let sort = document.querySelector(
      ".yotpo-dropdown-closable.yotpo-reviews-widget-dropdown"
    );
    if (sort) {
      //validate varible

      let newRviewBtn = document.querySelector('.yotpo-new-review-btn');
      newRviewBtn.addEventListener('keydown', function(event){
        if (event.key === "Enter") {
          setTimeout(() => {
            let closeNewRview = document.querySelector('#newReviewFormModal .btn-close');
            closeNewRview.addEventListener('keydown', function(event){
              if (event.key === "Enter") {
                document.querySelector('#newReviewFormModal').style.display="none"
                newRviewBtn.focus();
                setTimeout(() => {
                  document.querySelector('body').style.overflowY="auto"
                }, 1000);
                
              }
            })
          }, 500);
          
         
          setTimeout(() => {
          let newRviewContainer = document.querySelector('#newReviewFormModal');
          let newRview = document.querySelector('#newReviewFormModal .yotpo-modal');
          let container = document.querySelector('.yotpo-base-layout');
          let atrrNewRview = document.createAttribute("tabindex");
          atrrNewRview.value = "0";
          newRview.setAttributeNode(atrrNewRview);
          container.appendChild(newRviewContainer);
          newRview.focus()
        }, 300);
        }
      });

     

      let atrrSort = document.createAttribute("tabindex");
      atrrSort.value = "0";
      sort.setAttributeNode(atrrSort);

      let containerRatings = document.querySelector('.yotpo-score-filter.yotpo-score-filter-container');
      let atrrRatings = document.createAttribute("tabindex");
      atrrRatings.value = "-1";
      containerRatings.setAttributeNode(atrrRatings);

      let tabs = document.querySelectorAll('.yotpo-main-widget-tabs .ugc-storefront-widgets-tabs-container__tab');
      tabs.forEach(function(tab,index){
        let atrrTabs = document.createAttribute("tabindex");
        atrrTabs.value = "0";
        tab.setAttributeNode(atrrTabs);
      })

      tabs[0].addEventListener('keydown', function(e){
        if(e.key === "Enter") {
          
          tabs.forEach(function(tab){
            tab.classList.remove('selected')
          })
          e.target.classList.add('selected');
          let container = document.querySelector('.yotpo-base-layout');
          document.querySelector('.yotpo-base-layout .yotpo-widget-instance').style.display='none';
          document.querySelector('.yotpo-base-layout .yotpo-main-layout').style.display="flex"
        }
      })

      tabs[1].addEventListener('keydown', function(e){
        if(e.key === "Enter") {

          let btn = document.querySelector('.yotpo-base-layout #yotpo-widget-btn');
    
          btn.addEventListener('keydown', function(event){
            if (event.key === "Enter") {
              let btnAsk = document.querySelector('.yotpo-question-btn').click();
              setTimeout(() => {
                let modal = document.querySelector('.yotpo-device-desktop .yotpo-question-form-modal');
                let container = document.querySelector('.yotpo-base-layout');
                container.appendChild(modal);
          
                modal.focus()
              }, 300);
             
            }
          });
         
          tabs.forEach(function(tab){
            tab.classList.remove('selected')
          })
          e.target.classList.add('selected');
          
          document.querySelector('.yotpo-base-layout .yotpo-widget-instance').style.display='block'
          document.querySelector('.yotpo-base-layout .yotpo-main-layout').style.display="none"
        }
      });

      let title = document.querySelector('.yotpo-base-layout .yotpo-headline');
      let atrrTitle = document.createAttribute("tabindex");
      atrrTitle.value = "0";
      title.setAttributeNode(atrrTitle);
      let reviews = document.querySelector('.yotpo-base-layout .yotpo-bottom-line-summary');
      let atrrReviews = document.createAttribute("tabindex");
      atrrReviews.value = "0";
      reviews.setAttributeNode(atrrReviews);
    }
  },20000);

  let subscribe = document.querySelectorAll('.rc-template__legacy-radio .rc-radio__label');
  subscribe.forEach(function(label){
    let tabindex = document.createAttribute("tabindex");
      tabindex.value = "0";
      label.setAttributeNode(tabindex);
  })

  let intervalModal = setInterval(modal, 1000); //add interval to waiting for the cookie div load

  function modal() {
    let modal = document.querySelector(".bx-slab");
    if (modal) {
      let bxModal = document.querySelectorAll('.bx-ally-tab-decoy')
      bxModal.forEach(function(modal){
      modal.setAttribute('aria-hidden','false');

      let tabindexModal = document.createAttribute("tabindex");
      tabindexModal.value = "-1";
      modal.setAttributeNode(tabindexModal);
      
    })
      clearInterval(intervalModal);
    }
  }

  setTimeout(() => {
    clearInterval(intervalModal)
  }, 30000);

  let toggleIconMenu = document.querySelector('.toggle-menu.menu-link');
  toggleIconMenu && toggleIconMenu.addEventListener('click', function(e){
    let header = document.querySelector('.global-header');
    setTimeout(() => {
      header.setAttribute('aria-hidden', false)
    }, 500);
  
  })

  let btnCart = document.querySelector('.product-template .default-cart-button');
  btnCart && btnCart.addEventListener('click', function(e){
    document.querySelector('.cart-preview').focus()
  });

  let btnClose = document.querySelector('.cart-close-modal');
  if (btnClose) {
    btnClose.addEventListener('click', function(e){
      e.preventDefault()
      document.querySelector('.cart-preview').style.display='none';
      document.querySelector('.selection-wrapper button.button').focus()
      const elementoConFoco = document.activeElement;
      //console.log("El elemento con foco es:", elementoConFoco);     
    })
  }
});

//convert label to button and remove aria-labbely= open dialog

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
      var elements = document.querySelectorAll('.ls-carousel-photo');

      function updateAriaAttributes(element) {
          if (element.hasAttribute('aria-describedby')) {
              const ariaDescription = element.getAttribute('aria-describedby');
              //console.log('Cambiando aria-describedby a aria-label en el elemento.');
              element.setAttribute('aria-label', ariaDescription);
              element.removeAttribute('aria-describedby');
          }

          if (element.hasAttribute('aria-labelledby')) {
              //console.log('Eliminando atributo aria-labelledby del elemento.');
              element.removeAttribute('aria-labelledby');
          }

          if (element.hasAttribute('aria-label') && element.getAttribute('aria-label') === 'null') {
              const img = element.querySelector('img');
              if (img && img.hasAttribute('alt')) {
                  const imgAltText = img.getAttribute('alt');
                  //console.log('Actualizando aria-label con el alt de la imagen:', imgAltText);
                  element.setAttribute('aria-label', imgAltText);
              }
          }
      }

      elements.forEach(function(element) {
          var button = document.createElement('button');
          
          Array.from(element.attributes).forEach(function(attr) {
              if (attr.name !== 'aria-labelledby' && attr.name !== 'aria-describedby') {
                  button.setAttribute(attr.name, attr.value);
              }
          });
          
          button.innerHTML = element.innerHTML;
          element.parentNode.replaceChild(button, element);

          updateAriaAttributes(button);
          var observer = new MutationObserver(function(mutationsList) {
              for (var mutation of mutationsList) {
                  if (mutation.type === 'attributes') {
                      updateAriaAttributes(button);
                  }
              }
          });
          observer.observe(button, { attributes: true });
      });
  }, 2000);
});
//pause slider 
document.addEventListener("DOMContentLoaded", function() {
  
  //slider hudson
  const carouselContainer = document.querySelector('.hudson-gallery');
  const observer = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach((mutation) => {
          if (mutation.type === 'childList') {
              const slickPrevButton = document.querySelector('.dh-slick-arrow.slick-prev.slick-arrow');
              if (slickPrevButton) {
                  slickPrevButton.setAttribute('tabindex', '0');
              }
  
              const slickNextButton = document.querySelector('.dh-slick-arrow.slick-next.slick-arrow');
              if (slickNextButton) {
                  slickNextButton.setAttribute('tabindex', '0');
              }

              const targetDivs = document.querySelectorAll('.ls-photo-wrapper.slick-slide');
              targetDivs.forEach((div) => {
                  if (div.getAttribute('aria-label') === 'null') {
                      div.setAttribute('aria-label', 'Dive into the science behind our Rescue Mask');
                  }
              });
          }
      });
  });
  
  const config = { childList: true, subtree: true };
  if (carouselContainer) {
      observer.observe(carouselContainer, config);
  }
});
